import * as zod from "zod";

export interface ConvenioVm {
    id: string;
    contaId: number;
    descricaoConta: string;
    descricao: string;
    numeroConvenio: string;
    carteiraConvenio: string;
    inativo: boolean;
}

export const zodConvenioVm = zod.object({
    id: zod.string(),
    contaId: zod.number(),
    descricaoConta: zod.string(),
    descricao: zod.string(),
    numeroConvenio: zod.string(),
    carteiraConvenio: zod.string(),
    inativo: zod.boolean(),
}, {message: "Selecione um convênio"}).refine((val) => val != null);

// Mesmos códigos usados nos parâmetros padrão do Convênio (TipoJuros/TipoMulta/TipoDesconto) e nos
// parâmetros do Boleto (CodigoJuros/CodigoMulta/CodigoDesconto) — o backend reaproveita a mesma
// tabela de código para os dois (EBoletoJurosCodigo/EBoletoMultaCodigo/EBoletoDescontoCodigo).
export enum EBoletoJurosCodigo {
    Isento = 1,
    ValorPorDia = 2,
    TaxaMensal = 3,
}

export enum EBoletoMultaCodigo {
    SemMulta = 1,
    ValorFixo = 2,
    PercentualFixo = 3,
}

export enum EBoletoDescontoCodigo {
    SemDesconto = 1,
    ValorFixoAteDataInformada = 2,
    PercentualFixoAteDataInformada = 3,
}

// Opções dos combos de tipo — usadas no cadastro de boleto e no "Gerar boleto" a partir de lançamentos.
export const opcoesCodigoDesconto = [
    {label: 'Sem desconto', value: EBoletoDescontoCodigo.SemDesconto},
    {label: 'Valor fixo até a data informada', value: EBoletoDescontoCodigo.ValorFixoAteDataInformada},
    {label: 'Percentual até a data informada', value: EBoletoDescontoCodigo.PercentualFixoAteDataInformada},
];

export const opcoesCodigoMulta = [
    {label: 'Sem multa', value: EBoletoMultaCodigo.SemMulta},
    {label: 'Valor fixo', value: EBoletoMultaCodigo.ValorFixo},
    {label: 'Percentual', value: EBoletoMultaCodigo.PercentualFixo},
];

export const opcoesCodigoJuros = [
    {label: 'Isento', value: EBoletoJurosCodigo.Isento},
    {label: 'Valor por dia', value: EBoletoJurosCodigo.ValorPorDia},
    {label: 'Taxa mensal', value: EBoletoJurosCodigo.TaxaMensal},
];
